import { FC } from 'react';
import { PageTitle } from '../../../../rbts/layout/core';
import { View } from './components/View';

const RolesPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={[]}>Roles</PageTitle>
      <View />
    </>
  );
};

export { RolesPage };
